// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"_4c489ca3","searchContainer":"_3bd152bf nowrap flex","searchInput":"b57b0119 f5 fw4 black relative"};